
import Hero from "@/kuruComponents/Hero";
import Menu from "@/kuruComponents/Menu";
import Services from "@/kuruComponents/Services";
import Projects from "@/kuruComponents/Projects";
import About from "@/kuruComponents/About";
import Footer from "@/kuruComponents/Footer";
import "./kuruHome.css"
// 删除 home3.module.css 的导入，因为文件不存在

export default function Home() {
    return (
        <main>
            <Hero />
            <Menu />
            <Services />
            <Projects />
            <About />
            <Footer />
        </main>
    );
}
